export default "../js/CustomConfiguration.js";